var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenDrawerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentFill",
    d: "M34.181648,44.1662791 L54.9343163,25.5756019 C55.6123227,24.9697364 56,24.1033251 56,23.2001729 C56,22.4124387 55.7080287,21.6561348 55.1740381,21.0659518 C53.9791938,19.7445536 51.9062829,19.6362577 50.5745713,20.8274793 L32.0003757,37.4654413 L13.4236738,20.8276725 C12.0935125,19.6364577 10.0213584,19.7447392 8.82668196,21.0659518 L8.7717564,21.1273575 L8.67249145,21.2454056 C8.24147293,21.7945697 8.00808095,22.4501158 8,23.1374431 L8.00568918,23.3676269 C8.05136574,24.2260941 8.42241635,25.0012066 9.06331883,25.5753797 L29.8213496,44.1657258 C31.0638285,45.2779992 32.9380369,45.2779992 34.181648,44.1662791 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDrawerIcon);
export default __webpack_public_path__ + "static/media/open-drawer-icon.a192102f5b27f647ad9964d50270587a.svg";
export { ForwardRef as ReactComponent };